import React from "react";
import { Button, Flex, Space, Typography } from "antd";

export interface ChipOption<T> {
  value: T;
  label: string;
}

interface Props<T extends string | number> {
  label: string;
  clearLabel: string;
  options: ChipOption<T>[];
  selected: T[];
  disabled: boolean;
  onToggle: (value: T) => void;
  onClear: () => void;
}

// Buttons rather than CheckableTag: they take the keyboard and say whether
// they are pressed.
function ChipGroup<T extends string | number>({
  label,
  clearLabel,
  options,
  selected,
  disabled,
  onToggle,
  onClear,
}: Props<T>) {
  return (
    <div role="group" aria-label={label}>
      <Space align="baseline" size={4} style={{ marginBottom: 10 }}>
        <Typography.Text strong>{label}</Typography.Text>
        <Button
          type="link"
          size="small"
          aria-label={clearLabel}
          disabled={disabled}
          onClick={onClear}
        >
          Quitar
        </Button>
      </Space>
      <Flex wrap gap={8}>
        {options.map((option) => {
          const pressed = selected.includes(option.value);
          return (
            <Button
              key={option.value}
              shape="round"
              type={pressed ? "primary" : "default"}
              aria-pressed={pressed}
              disabled={disabled}
              onClick={() => onToggle(option.value)}
            >
              {option.label}
            </Button>
          );
        })}
      </Flex>
    </div>
  );
}

export default ChipGroup;
